const WebUrl = "https://app.huashenherbs.com/";
const isDev = process.env.NODE_ENV === "development";
const baseUrlLocale = isDev
  ? "https://app.huashenherbs.com/api"
  : "https://app.huashenherbs.com/api";
// const baseUrlLocale = "http://192.168.1.31:3000/api";
const PLACEHOLDER_LINK = "#";

const constants = {
  WebUrl: WebUrl,
  baseUrlLocale: baseUrlLocale,
  acuity: {
    ownerId: "39018212",
    baseUrl: "https://app.acuityscheduling.com/schedule.php",
    userSubmissionFieldId: "19125745",
    embedScriptUrl: "https://embed.acuityscheduling.com/js/embed.js",
  },
  contact: {
    phoneNumber: "+1 631 943 3942",
    emailAddress: "brittany.finnegan1@gmail.com",
    officeAddress: "121 Pulaski Road, Kings Park, NY 11754",
  },
  socialLinks: {
    instagram: PLACEHOLDER_LINK,
    facebook: PLACEHOLDER_LINK,
    youtube: PLACEHOLDER_LINK,
    tikTok: PLACEHOLDER_LINK,
  },
};

export default constants;

// https://huashenherbs.com/term-and-conditions
// https://huashenherbs.com/privacy-policy
